module.exports = __webpack_public_path__ + "img/3-l.0cec1f69.png";